import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

export type BreadcrumbSegment = {
  label: string;
  to?: string;
};

type BreadcrumbContextValue = {
  segments: BreadcrumbSegment[];
  setBreadcrumbSegments: (segments: BreadcrumbSegment[]) => void;
};

const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [segments, setSegmentsState] = useState<BreadcrumbSegment[]>([]);

  const setBreadcrumbSegments = useCallback((next: BreadcrumbSegment[]) => {
    setSegmentsState(next);
  }, []);

  const value = useMemo(
    (): BreadcrumbContextValue => ({
      segments,
      setBreadcrumbSegments,
    }),
    [segments, setBreadcrumbSegments],
  );

  return (
    <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs(): BreadcrumbContextValue {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) {
    throw new Error("useBreadcrumbs must be used within BreadcrumbProvider");
  }
  return ctx;
}
